export default "/images/36b5003c56bb090a9200d373797a3cad.avif";